<div class="trial-banner" [class.trial-banner--expired]="isExpired" *ngIf="show" role="status">
  <span
    *ngIf="!isExpired"
    class="trial-banner__text"
    [innerHTML]="
      (daysRemaining === 1 ? 'HEADER.TRIAL.BANNER.DAY_LEFT' : 'HEADER.TRIAL.BANNER.DAYS_LEFT')
        | translate: { n: daysRemaining }
    "
  ></span>

  <span
    *ngIf="isExpired"
    class="trial-banner__text"
    [innerHTML]="'HEADER.TRIAL.BANNER.EXPIRED' | translate"
  ></span>
</div>
